import { createSlice } from "@reduxjs/toolkit";

export const controlServiceSlice = createSlice({
  name: "controlService",
  initialState: {
    status: "available",
    timestamp: null,
    serviceNames: [],
    services: [],
    activeServiceTab: null,
  },
  reducers: {
    changeControlServiceStatus: (state, action) => {
      state.status = action.payload;
    },
    setTimestamp: (state, action) => {
      state.timestamp = action.payload;
    },
    setServices(state, action) {
      state.services = action.payload;
      state.serviceNames = action.payload.map((item) => item.serviceName);
    },
    setActiveTab(state, action) {
      state.activeServiceTab = action.payload;
    },
  },
});

export const {
  changeControlServiceStatus,
  setTimestamp,
  setServices,
  setActiveTab,
} = controlServiceSlice.actions;

export const selectControlServiceStatus = (state) =>
  state.controlService.status;

export const selectTimestamp = (state) => state.controlService.timestamp;
export const selectServiceNames = (state) => state.controlService.serviceNames;

export const selectServices = (state) => state.controlService.services;
export const selectActiveServiceTab = (state) =>
  state.controlService.activeServiceTab;

export default controlServiceSlice.reducer;
